<template>
  <el-dialog
    title="Вопрос в техническую поддержку"
    :visible="visible"
    @update:visible="updateVisible">
    <el-form
      ref="form"
      label-position="top"
      :model="formData"
      :rules="rules"
      @submit.native.prevent="onSubmit">
      <el-form-item label="Тема обращения" prop="topic">
        <el-input v-model="formData.topic" name="topic" type="text" />
      </el-form-item>
      <el-form-item label="Текст обращения" prop="message">
        <el-input
          v-model="formData.message"
          name="message"
          type="textarea"
          :rows="4" />
      </el-form-item>
      <files-upload ref="filesUpload" @upload-complete="$emit('update-list')" />
      <div class="divider"></div>
      <div class="flex-x-center">
        <el-button
          :loading="$mip('createSupportRequest')"
          type="primary"
          size="medium"
          native-type="submit">
          Отправить
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { clearFormData } from '@/utils'
  import FilesUpload from './FilesUpload.vue'

  export default {
    components: {
      FilesUpload
    },

    props: {
      visible: Boolean
    },

    data() {
      return {
        formData: {
          topic: '',
          message: ''
        },
        rules: {
          topic: [
            { required: true, message: 'Пожалуйста, введите тему обращения', trigger: [ 'blur', 'change' ] }
          ],
          message: [
            { required: true, message: 'Пожалуйста, введите текст обращения', trigger: [ 'blur', 'change' ] }
          ]
        },
        associationId: ''
      }
    },

    methods: {
      async onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.createRequest()
          } else {
            console.error('Error: form validation')
            return false
          }
        })
      },

      async createRequest() {
        const { data: { associationId } } = await this.$http.createSupportRequest({
          topic: this.formData.topic,
          message: this.formData.message
        })

        this.$refs.filesUpload.startUploading(associationId)

        this.updateVisible(false)
        this.formData = clearFormData(this.formData)

        this.$notify({
          title: 'Вопрос отправлен',
          message: 'История переписки по этому вопросу будет доступна в разделе "Техподдержка"',
          type: 'success'
        })
      },

      updateVisible(val) {
        this.$emit('update:visible', val)
      }
    }
  }
</script>